import * as Sentry from '@sentry/react'
import {
  QueryCache,
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import './index.css'
import { App } from './App'
import { ErrorFallback } from './components/ErrorBoundary'
import { useToastStore } from './store/toast'

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.MODE,
})

const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error) => {
      Sentry.captureException(error)
      useToastStore.getState().addToast(error.message)
    },
  }),
})

window.addEventListener('unhandledrejection', (event) => {
  const msg =
    event.reason instanceof Error ? event.reason.message : String(event.reason)
  console.error('[unhandledrejection]', event.reason)
  Sentry.captureException(event.reason)
  useToastStore.getState().addToast(msg)
})

// biome-ignore lint/style/noNonNullAssertion: root element always exists in index.html
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Sentry.ErrorBoundary
      fallback={({ error, componentStack, resetError }) => (
        <ErrorFallback
          error={error}
          componentStack={componentStack}
          onReset={resetError}
          standalone
        />
      )}
    >
      <BrowserRouter>
        <QueryClientProvider client={queryClient}>
          <App />
        </QueryClientProvider>
      </BrowserRouter>
    </Sentry.ErrorBoundary>
  </StrictMode>,
)
